import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const updateWrongProcessOrder = createAction(Constants.UPDATE_WRONG_PROCESS_ORDER.REQUEST, (datas) => (datas));
